export enum ScooterBatteryType {
  REPLACEABLE = 'REPLACEABLE',
  NON_REPLACEABLE = 'NON_REPLACEABLE'
}

export enum ScooterBatteryStatus {
  ACTIVE = 'ACTIVE',
  CHARGING = 'CHARGING',
  MAINTENANCE = 'MAINTENANCE',
  REMOVED = 'REMOVED'
}

export enum ScooterBatteryLocation {
  SCOOTER = 'SCOOTER',
  CHARGING_STATION = 'CHARGING_STATION',
  WAREHOUSE = 'WAREHOUSE'
}

export enum ScooterBatteryAction {
  CHARGING_END = 'CHARGING_END',
  REMOVED_FROM_SCOOTER_FOR_CHARGING = 'REMOVED_FROM_SCOOTER_FOR_CHARGING',
  REMOVED_FROM_SCOOTER_FOR_MAINTENANCE = 'REMOVED_FROM_SCOOTER_FOR_MAINTENANCE',
  INSTALLED_TO_SCOOTER_AFTER_CHARGING = 'INSTALLED_TO_SCOOTER_AFTER_CHARGING',
  INSTALLED_TO_SCOOTER_AFTER_MAINTENANCE = 'INSTALLED_TO_SCOOTER_AFTER_MAINTENANCE'
}

export interface ChargingStation {
  _id: string;
  name: string;
  city?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface ScooterType {
  _id: string;
  name: string;
}

export interface ScooterBattery {
  _id: string;
  city?: string;
  scooter?: {
    _id: string;
    name: string;
  } | null;
  chargingStation?: {
    _id: string;
    name: string;
  } | null;
  scooterTypes?: ScooterType[] | string[];
  location: ScooterBatteryLocation;
  name: string;
  code: string;
  comment?: string;
  type: ScooterBatteryType;
  status: ScooterBatteryStatus;
  chargeLevel: number;
  healthLevel: number;
  cycles: number;
  lastScanDate?: string;
  lastServiceDate?: string;
  manufactureDate?: string;
  installDate?: string;
  lastChargeDate?: string;
  ridesSinceCharge: number;
  mileageSinceCharge: number;
  totalRides: number;
  totalMileage: number;
  idleDischargePercent: number;
  faultCount: number;
  createdAt?: string;
  updatedAt?: string;
  efficiency?: number;
}

export interface BatteryHistory {
  _id: string;
  scooterBattery: string;
  scooter?: {
    _id: string;
    name: string;
  };
  chargingStation?: {
    _id: string;
    name: string;
  };
  adminLogin: string;
  batteryLevel: number;
  action: ScooterBatteryAction;
  createdAt: string;
  updatedAt: string;
}

export interface BatteryStats {
  active: number;
  charging: number;
  maintenance: number;
  healthLt60: number;
}

export interface BatteryEfficiencyStats {
  total: number;
  avgMileage: number;
  avgEfficiency: number;
  topPerformer: ScooterBattery | null;
}

export interface CreateChargingStationBody {
  name: string;
}

export interface UpdateChargingStationBody {
  name: string;
}

export interface CreateBatteryBody {
  name: string;
  code: string;
  scooterTypes?: string[];
  comment?: string;
  type: ScooterBatteryType;
  status: ScooterBatteryStatus;
  chargeLevel: number;
  healthLevel: number;
  cycles: number;
  location: ScooterBatteryLocation;
  scooter?: string | null;
  chargingStation?: string | null;
  lastScanDate?: string;
  lastServiceDate?: string;
  manufactureDate?: string;
  installDate?: string;
  idleDischargePercent: number;
  faultCount: number;
}

export interface UpdateBatteryBody extends CreateBatteryBody {}

export interface CreateBatteryHistoryBody {
  scooterBattery: string;
  action: ScooterBatteryAction;
  scooter?: string;
  chargingStation?: string;
  batteryLevel: number;
}

export interface GetBatteriesParams {
  page?: number;
  limit?: number;
  name?: string;
  code?: string;
  type?: ScooterBatteryType;
  scooter?: string;
  chargingStation?: string;
  status?: ScooterBatteryStatus;
  scooterTypes?: string;
}

export interface GetBatteryHistoryParams {
  scooterBattery: string;
}
